import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BookingService {

  constructor(private http: HttpClient) { }

  getBookingDetails(currency: any, status: any): Observable<any> {
    return this.http.get(`${environment.bookingApiUrl}/customerbooking?currency=${currency}&status=${status}`);
  }

  getPromocode(): Observable<any> {
    return this.http.get(`${environment.bookingApiUrl}/my_offer`);
  }

  checkClubPassBalance(): Observable<any> {
    return this.http.get(`${environment.bookingApiUrl}/check-club-pass-balance`);
  }

  getCancellationCharges(product_id: any, booking_id: any, ticket_id: any): Observable<any> {
    return this.http.get(
      `${environment.bookingApiUrl}/cancellation_charges?product_id=${product_id}&booking_id=${booking_id}&ticket_id=${ticket_id}`
    );
  }

  postConfirmCancellation(data: any): Observable<any> {
    return this.http.post(`${environment.bookingApiUrl}/confirm-cancellation`, data);
  }
  postGrievanceCreateAppend(data: any): Observable<any> {
    return this.http.post(`${environment.bookingApiUrl}/grievance-create-append`, data);
  }
  
  
  getGrievanceList(booking_item_id: any): Observable<any> {
    return this.http.get(
      `${environment.bookingApiUrl}/grievance-list/${booking_item_id}`
    );
  }

  postGallery(data: any): Observable<any> {
    return this.http.post(`${environment.bookingApiUrl}/gallery`, data, {
      reportProgress: true,
      observe: 'events',
    });
  }

}
